import { useState } from "react";
import { AccordionContent } from "./styles";

export default function Accordion({ title, children }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <AccordionContent>
      <div onClick={() => setIsOpen(!isOpen)} className="AccordionHeader">
        <span className="AccordionTitle">{title}</span>
        <span className="AccordionIcon">{isOpen ? "-" : "+"}</span>
      </div>
      {isOpen && <div className="AccordionBody">{children}</div>}
    </AccordionContent>
  );
}
